import { Component, OnInit } from '@angular/core';
import {
    BackOfficeEnum,
    MenuPermissionActionEnum,
    MenuPermissionConfig,
    DriverCampaignType,
    RootMenuEnum,
    ServiceTypeEnum,
    UsersDisiplinaryFilterEnum
} from 'app/models';
import { AppDataService } from 'app/services';
import { MenuHomeEnum } from 'app/components/home';
import { AppComponent } from 'app/app.component';
import { ProvideTestId } from 'app/providers';

@Component({
    selector: 'back-office-root',
    providers: [ProvideTestId('back-office')],
    templateUrl: './back-office-root.component.html',
    styleUrls: ['./back-office-root.component.scss',
        '../../../../styles/menu-sidebar.scss'
    ],
})
export class BackOfficeRootComponent implements OnInit {

    public riderCampaignTypeEnum = DriverCampaignType;

    public backOfficeActive!: BackOfficeEnum;
    public serviceTypeId!: ServiceTypeEnum;

    public usersDisiplinaryFilterEnum = UsersDisiplinaryFilterEnum;
    public usersDisiplinaryFilterActive!: UsersDisiplinaryFilterEnum;

    constructor(public appData: AppDataService,
                public app: AppComponent) { }

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    public activeRootMenu: RootMenuEnum | null = null;

    public menuEnum = MenuHomeEnum;
    public activeMenu: MenuHomeEnum = MenuHomeEnum.Dashboard;

    ngOnInit(): void {
        this.activeRootMenu = this.appData.activeRootMenu;
    }

    public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum, backOffice: BackOfficeEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
        this.backOfficeActive = backOffice;
        switch (menu) {
            case MenuHomeEnum.SuspendedUser:
                this.usersDisiplinaryFilterActive = UsersDisiplinaryFilterEnum.Suspended;
                break;
            case MenuHomeEnum.BlacklistUsers:
                this.usersDisiplinaryFilterActive = UsersDisiplinaryFilterEnum.Blacklist;
                break;
            default: break;
        }
    }

    public getDriverType() {
        switch (this.backOfficeActive) {
            case BackOfficeEnum.Passenger2W: return 'Passenger 2W';
            case BackOfficeEnum.Passenger3W:
                return (this.activeMenu === MenuHomeEnum.CompaignDrivers && this.appData.isBoracayLocation) ? 'Campaign 3W' : 'Passenger 3W';
            case BackOfficeEnum.Passenger4W:
                return (this.activeMenu === MenuHomeEnum.CompaignDrivers && this.appData.isBoracayLocation) ? 'Campaign 4W' : 'Passenger 4W';
            case BackOfficeEnum.Delivery2W: return 'Delivery 2W';
            case BackOfficeEnum.Delivery3W: return 'Delivery 3W';
            case BackOfficeEnum.Delivery4W: return 'Delivery 4W';
            default: return '';
        }
    }

    public getMenuValue() {
        switch (this.activeMenu) {
            case MenuHomeEnum.MartOnboarding: return 'Marts Partner';
            case MenuHomeEnum.FoodOnboarding: return 'Eats Partner';
            case MenuHomeEnum.DisciplinaryNewCases: return 'New Cases';
            case MenuHomeEnum.DisciplinaryInProcess: return 'In Process';
            case MenuHomeEnum.DisciplinaryArchived: return 'Archived';
            case MenuHomeEnum.ActiveDrivers: return 'Active Drivers';
            case MenuHomeEnum.DraftDrivers: return 'Draft Registration';
            case MenuHomeEnum.CompaignDrivers: return 'Campaign Drivers';
            case MenuHomeEnum.CompaignXpress50Drivers: return 'Xpress 50';
            case MenuHomeEnum.Xpress50Riders4W: return '4RXP';
            case MenuHomeEnum.PriorityOrderDrivers: return 'Priority orders';
            case MenuHomeEnum.Xpress2WEV: return '2W EV';
			case MenuHomeEnum.Xpress4WEV: return '4W EV';
			case MenuHomeEnum.Xpress4WEVBataan: return 'Bataan Full-EV Drivers';
            case MenuHomeEnum.LoopPassCampaign: return 'Loop Pass Drivers';
            case MenuHomeEnum.Taxi: return 'Taxi';
            case MenuHomeEnum.ConneX: return 'ConneX';
            case MenuHomeEnum.TaxiVehicles: return 'Taxi Vehicles';
            case MenuHomeEnum.ConneXVehicles: return 'ConneX Vehicles';
            default: return '';
        }
    }
}
